<mat-expansion-panel
  class="filterbar__item checkbox-filter mat-elevation-z0"
  *ngIf="category?.options?.length > 0">
  <mat-expansion-panel-header>
    <div
      class="checkbox-filter__title"
      [class.active]="anySelected">
      {{ category.title | translate }}
    </div>
  </mat-expansion-panel-header>
  <form
    *ngIf="category.options?.length > 5"
    #f="ngForm"
    class="c-search-filter-form">
    <div class="c-input-group">
      <input
        type="text"
        name="search"
        id="input-search"
        class="c-input c-input--alpha c-input--main"
        [(ngModel)]="search"
        (keyup)="onSearchChange()"
        placeholder="Search for {{ category.title | translate }}" />
      <span
        *ngIf="!search"
        id="tools-search"
        class="c-button c-button--search"></span>
      <span
        *ngIf="search"
        id="tools-search"
        (click)="search = null; onSearchChange()"
        class="c-button c-button--search c-close-search"></span>
    </div>
  </form>
  <ul
    class="o-list"
    id="models">
    <li
      class="o-list__item u-pt--small u-pb--small"
      *ngFor="let option of filteredOptions | slice: 0 : limitTo">
      <mat-checkbox
        [(ngModel)]="option.selected"
        (ngModelChange)="onColumnFilterChange()"
        labelPosition="before"
        class="c-input-checkbox">
        {{
          (option.key ? (option.title ? option.title : option.key) : "toolfilters.none")
            | translate
        }}<span class="c-counter">({{ option.count }})</span>
      </mat-checkbox>
    </li>
    <li class="o-list__item u-pt--small u-pb--small">
      <label
        class="c-input-checkbox c-label"
        *ngIf="filteredOptions?.length > 5">
        <a
          *ngIf="limitTo === 5"
          type="button"
          class="c-link"
          (click)="limitTo = 1000">
          {{ "toolfilters.seeall" | translate }}
        </a>
        <a
          *ngIf="limitTo === 1000"
          type="button"
          class="c-link"
          (click)="limitTo = 5">
          {{ "toolfilters.seeless" | translate }}
        </a>
      </label>
    </li>
  </ul>
</mat-expansion-panel>
